import { Link } from 'react-router-dom';

/**
 * LandingFooter Component
 *
 * Themed footer with logo, navigation links, and copyright.
 */
export function LandingFooter() {
  return (
    <footer className="landing-footer">
      <div className="landing-footer__content">
        <img
          src="/assets/logo.png"
          alt="ClosedLoopDiving"
          className="landing-footer__logo"
        />
        <nav className="landing-footer__nav">
          <Link to="/terms" className="landing-footer__link">
            Terms
          </Link>
          <Link to="/privacy" className="landing-footer__link">
            Privacy
          </Link>
          <Link to="/about" className="landing-footer__link">
            About
          </Link>
          <Link to="/instructor/register" className="landing-footer__link">
            Instructors
          </Link>
          <a href="mailto:support@closedloopdiving.com" className="landing-footer__link">
            Contact
          </a>
        </nav>
        <p className="landing-footer__copyright">
          {new Date().getFullYear()} Closed Loop Diving. Technical diving education for the modern
          diver.
        </p>
      </div>
    </footer>
  );
}
